import loadable from '@loadable/component'

export default [
  {
    // 帮助中心
    path: '/Helping/Center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-Center" */ '~/pages/Helping/Center'
        )
    ),
  },
  {
    // 问题合集
    path: '/Helping/QuestionTypes',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-QuestionTypes" */ '~/pages/Helping/QuestionTypes'
        )
    ),
  },
  {
    // 工单历史列表
    path: '/Helping/ReportList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-ReportList" */ '~/pages/Helping/ReportList'
        )
    ),
  },
  {
    // 工单结果反馈
    path: '/Helping/ReportResNotify',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-ReportResNotify" */ '~/pages/Helping/ReportResNotify'
        )
    ),
  },
  {
    // 工单详情
    path: '/Helping/ReportDetails',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-ReportDetails" */ '~/pages/Helping/ReportDetails'
        )
    ),
  },
]
